export const EVENT_REVIEW_TAGS = {
  'good-mood': { value: 'good-mood', isNegative: false },
  'welcoming': { value: 'welcoming', isNegative: false },
  'cool-people': { value: 'cool-people', isNegative: false },
  'nice-planning': { value: 'nice-planning', isNegative: false },
  'great-place': { value: 'great-place', isNegative: false },
  'fun-activity': { value: 'fun-activity', isNegative: false },

  'not-included': { value: 'not-included', isNegative: true },
  'bad-place': { value: 'bad-place', isNegative: true },
  'too-many-people': { value: 'too-many-people', isNegative: true },
  'not-enough-people': { value: 'not-enough-people', isNegative: true },
  'did-not-liked': { value: 'did-not-liked', isNegative: true }
} as const